import { getDefaultInputState } from '@/store';
import { isBoolean } from '@checkout/react-components';
import { getContent } from '@/lib/content';

const getFieldPayload = ({ value, isValid, ...rest }) => {
  const newIsValid = isBoolean(isValid) ? isValid : Boolean(value);
  const payload = {
    ...getDefaultInputState(),
    isValid: newIsValid,
    ...rest,
    value: value || '', // Handle null as value
  };

  return payload;
};

const constructAddressAutoPopulationPayload = ansResponse => {
  const { city, line1, line2, postalCode, state } = ansResponse;

  const payload = {
    city: getFieldPayload({ field: 'city', value: city }),
    houseNumber: getFieldPayload({
      error: getContent('fieldErrors.valueMissing'),
      errorCode: 'valueMissing',
      field: 'houseNumber',
      isValid: false,
      value: '',
    }),
    line1: getFieldPayload({
      error: getContent('fieldErrors.valueMissing'),
      errorCode: 'valueMissing',
      field: 'line1',
      isValid: false,
      value: line1,
    }),
    line2: getFieldPayload({ field: 'line2', value: line2 }),
    postalCode: getFieldPayload({ field: 'postalCode', value: postalCode }),
    state: getFieldPayload({ field: 'state', value: state.toUpperCase() }),
    // line 1 in the response only has street name. Therefore, we assign it
    // to the street name field.
    streetName: getFieldPayload({ field: 'streetName', value: line1 }),
  };

  return payload;
};

export { constructAddressAutoPopulationPayload };
